import { render, staticRenderFns } from "./ModifyWalletAmount.vue?vue&type=template&id=70b0e732&"
import script from "./ModifyWalletAmount.vue?vue&type=script&lang=js&"
export * from "./ModifyWalletAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports